/**
 * Tiện ích trích xuất thông báo lỗi từ response API (Axios).
 *
 * Ưu tiên: lỗi field đầu tiên → message chung → fallback.
 * Bỏ qua key i18n chưa resolve (messages.*, validation.*, labels.*).
 */

/** Kiểm tra chuỗi có phải key dịch chưa được resolve không */
const isUnresolvedTranslationKey = (value) =>
  typeof value === 'string'
  && (value.startsWith('messages.') || value.startsWith('validation.') || value.startsWith('labels.'));

/**
 * Lấy thông báo lỗi thân thiện từ object lỗi API.
 * @param {Error} error - Lỗi từ apiClient (thường là Axios error)
 * @param {string} fallbackMessage - Thông báo mặc định khi không parse được
 * @returns {string}
 */
export const getApiErrorMessage = (error, fallbackMessage) => {
  const data = error?.response?.data;

  if (!data) {
    return fallbackMessage;
  }

  // Laravel validation errors: { errors: { field: ['msg'] } }
  if (data.errors && typeof data.errors === 'object') {
    const firstFieldError = Object.values(data.errors)
      .flat()
      .find((message) => typeof message === 'string' && message.trim());

    if (firstFieldError && !isUnresolvedTranslationKey(firstFieldError)) {
      return firstFieldError;
    }
  }

  const message = data.message;

  if (typeof message === 'string' && message.trim() && !isUnresolvedTranslationKey(message)) {
    return message;
  }

  return fallbackMessage;
};
